import React, { useRef } from 'react'
import {
  FormControl,
  IconButton,
  InputAdornment,
  TextField
} from '@mui/material'
import { faCircleXmark } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useTranslation } from 'react-i18next'
import { FreeFormClasses } from '../../styles/classes/AccountSettingsClasses'

// eslint-disable-next-line react/display-name
export const FreeFormInput = React.forwardRef(
  (
    {
      handleChange,
      id,
      name,
      value,
      placeholder,
      error,
      helperText,
      type,
      label,
      inputStyle,
      endAdornment,
      ...rest
    },
    ref
  ) => {
    const { classes } = FreeFormClasses()
    const inputRef = useRef()
    const { t } = useTranslation()

    const handleChangeInt = (event) => {
      handleChange(event, id)
    }

    return (
      <FormControl fullWidth className={classes.formControl}>
        <TextField
          id={id}
          name={name}
          key={id}
          value={value}
          label={label}
          onKeyUp={handleChange}
          size="small"
          variant="filled"
          margin="normal"
          inputRef={inputRef}
          InputProps={{
            className: classes.textField,
            style: inputStyle,
            disableUnderline: true,
            endAdornment: endAdornment && (
              <InputAdornment position="end">
                {value && (
                  <IconButton
                    aria-label="Clear contents"
                    onClick={() => {
                      handleChange({ target: { name, value: '' } }, id)
                    }}
                    className={classes.icon}
                    size="small"
                  >
                    <FontAwesomeIcon icon={faCircleXmark} className={classes.icon}/>
                  </IconButton>
                )}
              </InputAdornment>
            )
          }}
          InputLabelProps={{
            className: classes.label
          }}
          placeholder={
            !placeholder ? t('account_settings.form.enter') + ' ' + label : placeholder
          }
          classes={{ root: classes.root }}
          autoComplete="off"
          error={error}
          helperText={helperText}
          ref={ref}
          type={type ?? 'text'}
          onInput={handleChangeInt}
          {...rest}
        />
      </FormControl>
    )
  }
)
